import React from 'react';
import styled from 'styled-components';

import PlaintextEditor from 'components/composer/editors/plaintext';

const SubjectContainer = styled.div.attrs({ 'data-aid': 'slate-subject-container' })`
  display: flex;
  justify-content: space-between;

  .slateTextEditor {
    flex-shrink: 1;
    font-weight: bold;
    flex-basis: 200px;
  }
`;

export function Subject(props) {
  return <PlaintextEditor data-aid="slate-email-subject" placeholder="Subject line" {...props} />;
}

export { SubjectContainer };
export default Subject;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/email/subject.jsx